<template>
  <div class="welcome-container" style="background-image: url(./greenBackground.jpg">
    <div class="header">
      <div class="logo">
        <img src="../assets/logo_green.png"/>
      </div>
    </div>
    <div class="content">

      <div class="welcome-text">
        HERZLICH WILLKOMMEN BEI <span> #WEIDEN<span
                                               class="yellow-text">2040</span></span>
      </div>

      <div>
      Die Vision von B90/Die Grünen in Weiden für
      ein schöneres, besseres und lebenswerters Weiden.
      <br>
      Mit konsequentem Willen zur Gestaltung, Weitsicht,
      Standhaftigkeit und Beharrlichkeit wollen wird Weiden zu einer
      nachhaltigen, gerechten und lebenswerten Stadt machen.
      </div>

      <div class="vote-container">
        <div class="vote">
          <span class="yellow-text">ZUKUNFT</span>? DU WILLST SIE?
          <br>
          DANN WÄHL SIE!
        </div>
      </div>

    </div>
    <div class="button-container">
      <div class="button secondary-bg" @click="go()">
        <b>Los geht's</b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    go() {
      this.$router.push('/menu')
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';
.welcome-container {
  position: relative;
  @include gradient;
  padding-bottom: 120px;
  text-align: left;
}


.welcome-text {
  font-family: 'Arvo Gruen';
  text-align: center;
  padding-bottom: 20px;
}

.content {
  padding: 20px;
  padding-bottom: 20px;
  text-align: justify;
}

.vote-container {
  text-align: center;
}

.vote {
  font-family: 'Arvo Gruen';
  display: inline-block;
  margin-top: 30px;
  margin-bottom: 20px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-top: 2px solid white;
  border-bottom: 2px solid white;
}

.logo {
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
